const simplePopup = require('../../components/simplePopup/simplePopup.js');

Vue.component('deal-promo-box', {
    props: {
        box: Object,
        promoIndex: Number,
        hideOnMobile: Boolean,
        settings: Object
    },
    mounted: function () {
        // Must manually trigger slimmage after finished loading
        window.slimmage.checkResponsiveImages();
        simplePopup.initialize('[data-promo-trigger="' + this.promoIndex + '"]');
    },
    template: `
        <div class="vacation-search-result" v-if="box" :class="{'hide-mobile': hideOnMobile}">
            <div class="destination-card result-card getaway-deal-card">
                <div class="dc-details">
                    <div class="getaway-subtitle" v-if="box.smallTitle">
                        <img v-if="box.logoImage" data-slimmage="true" class="getaway-subtitle-logo" alt="aarp-logo" src="/images/blank.png" v-bind:data-src="box.logoImage.url" />
                        <span class="getaway-subtitle-text" v-html="box.smallTitle"></span>
                    </div>
                    <div class="getaway-primary-title" v-if="box.largeTitle">
                        <span v-html="box.largeTitle"></span>
                    </div>
                    <div class="getaway-body-text" v-if="box.text">
                        <p>{{box.text}}</p>
                    </div>
                    <div class="getaway-link" v-if="box.link">
                        <a :href="box.link.url"
                           :class="['getaway-' + box.linkStyleClass + ' ' + box.link.popupTargetClass]"
                           :target="box.link.target"
                           :data-promo-trigger='promoIndex'>{{box.link.linkText}}</a>
                    </div>
                </div>
            </div>
        </div>
    `
});